/**
 * Tiny wrapper around Plausible custom events.
 * Safe no-op if the script hasn't loaded (offline / blocked / dev).
 *
 * Usage:
 *   import { track } from "../lib/track";
 *   track("PAT Connected");
 *   track("Project Created", { props: { repo: "owner/repo" } });
 */
export function track(eventName, options = undefined) {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.plausible === "function") {
      window.plausible(eventName, options);
    }
  } catch {
    // swallow — analytics must never break the app
  }
}
